import CollectModal from '../component/collectModal'
import dyTrackUtil from './dyTrack'
import request from './request'
import util from './util'

const SHOP_TYPE = {
  dyxd: 100
}

const GOODS_TYPE = {
  douyin: 100,
  taobao: 101,
  tmall: 102
}

export default {
  /**
   * 店铺明细
   * @param {string} shopInfo.coverUrl 封面图
   * @param {string} shopInfo.shopName 店铺名称
   * @param {boolean} shopInfo.includedFlag  是否收录
   * @param {number} shopInfo.sourceType 店铺来源
   * */
  toShopDetail(shopId, shopInfo) {
    // 未收录的抖音小店
    if (shopInfo && shopInfo.sourceType === SHOP_TYPE.dyxd && !shopInfo.includedFlag) {
      return
    }
    // 未收录店铺的情形
    if (shopInfo && !shopInfo.includedFlag) {
      CollectModal.show({
        baseInfo: shopInfo,
        type: CollectModal.TYPE.shop,
        id: shopId,
      })
      return
    }

    request.post('/user/track-log', {
      code: 1000006,
      content: {
        shopId,
        type: '事件埋点',
        name: document.title,
        source_page: window.sessionHistory[0],
        target_page: window.location.pathname.substring(1).replace('/', '_') + window.location.hash.replace('#', '_'),
        client: 'web'
      }
    })
    if (shopInfo?.sourceType === SHOP_TYPE.dyxd) {
      window.open(`/douyin/shopDetail?shopId=${shopId}`)
      dyTrackUtil.track('DY_shop', {
        ...dyTrackUtil.getDyTrackModule(),
        shopId,
        shopName: shopInfo.shopName
      })
    } else {
      window.open(`/shopDetail?shopId=${shopId}`)
      util.track('storeDetails', {
        shopId,
        shopName: shopInfo?.title,
        ...util.getTrackModule(),
        type: '查看店铺详情',
      })
    }
  },
  /**
   * 商品明细
   * @param {string} itemInfo.coverUrl  封面图
   * @param {string} itemInfo.title  商品名称
   * @param {string} itemInfo.shopName  店铺名称
   * @param {number} itemInfo.goodsType  商品类型
   * @param {boolean} itemInfo.includedFlag  是否收录
   * */
  toGoodDetail(itemId, itemInfo = null, module = null) {
    // 未收录的淘系商品，进入收录流程
    if (itemInfo && !itemInfo.includedFlag && itemInfo.goodsType === GOODS_TYPE.taobao) {
      CollectModal.show({
        baseInfo: itemInfo,
        type: CollectModal.TYPE.item,
        id: itemId
      })
      return
    }

    // 未收录抖音商品跳转至外链
    if (itemInfo && !itemInfo.includedFlag && itemInfo.goodsType === GOODS_TYPE.douyin) {
      this.toDouyinGoodsDetail(itemId)
      return
    }

    // 跳转至站内
    window.open(`/itemDetail?itemId=${itemId}`)

    // 触发埋点
    request.post('/user/track-log', {
      code: 1000007,
      content: {
        itemId,
        type: '事件埋点',
        name: document.title,
        source_page: window.sessionHistory[0],
        target_page: window.location.pathname.substring(1).replace('/', '_') + window.location.hash.replace('#', '_'),
        client: 'web'
      }
    })
    util.track('goodsDetails', { ...util.getTrackModule(), itemId, itemName: itemInfo?.title, type: '商品详情' })
    let params = {}
    if (module && module === '搜抖音') {
      params.module1 = '搜索'
      params.module2 = '搜索预览'
    } else {
      params = { ...params, ...dyTrackUtil.getDyTrackModule() }
    }
    if (location.pathname.indexOf('douyin') !== -1) {
      dyTrackUtil.track('DY_goodsDetails', {
        ...params,
        itemId,
        itemName: itemInfo?.title || itemInfo?.itemTitle || itemInfo
      })
    }
  },
  toDouyinGoodsDetail(itemId, title) {
    window.open(`https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?id=${itemId}`)
    dyTrackUtil.track('DY_goodsDetails', {
      ...dyTrackUtil.getDyTrackModule(),
      itemId,
      itemName: title
    })
  },
  // 淘宝店铺明细
  toTaobaoShopDetail(shopId, url) {
    request.post('/user/track-log', {
      code: 1000008,
      content: {
        shopId,
        type: '事件埋点',
        name: document.title,
        source_page: window.sessionHistory[0],
        target_page: window.location.pathname.substring(1).replace('/', '_') + window.location.hash.replace('#', '_'),
        client: 'web'
      }
    })
    if (url) {
      window.open(url)
    } else {
      window.open(`https://shop${shopId}.taobao.com/`)
    }
  },
  // 淘宝商品明细
  toTaobaoGoodDetail(itemId, itemName, url) {
    request.post('/user/track-log', {
      code: 1000009,
      content: {
        itemId,
        type: '事件埋点',
        name: document.title,
        source_page: window.sessionHistory[0],
        target_page: window.location.pathname.substring(1).replace('/', '_') + window.location.hash.replace('#', '_'),
        client: 'web'
      }
    })
    if (url) {
      window.open(url)
    } else {
      window.open(request.taobaoUrlHost + itemId)
    }
  },
}
